import StatusPage from './StatusPage.jsx';

/**
 * 404 — no such route.
 *
 * Wired as the router's catch-all, and also the placeholder target for every
 * navigation entry whose page component has not been generated yet (see
 * `routeForSlug` in src/config/menuData.js). ui-components-from-reference
 * re-points each entry at its real route as the page is built.
 */
export default function NotFound404() {
  return (
    <StatusPage
      code="404"
      title="We couldn't find that page"
      message="The page you asked for doesn't exist, has moved, or hasn't been built yet. Pick a destination from the menu to carry on."
      icon="fa fa-map-signs"
      tone="info"
    />
  );
}
